<template>
  <div class="exchange-i">
    <Header title="教学课程查询" type="0" route="/teacher/jxkccx?isBack=1"></Header>
    <NOdata
      v-if="this.exchangeList && this.exchangeList.length == 0"
      title="未查询到任何信息"
    ></NOdata>
    <div class="exchange">
      <div
        class="item"
        v-for="(item, index) of exchangeList"
        :key="index"
      >
        <ul>
          <li class='curpepother'><span>教学场馆：</span>{{ item.classroom }}</li>
          <li class='curpepother'><span>上课时间：</span>{{ item.time }}</li>
          <li class='curpepother'><span>任务号：</span>{{ item.jx0404id }}</li>
          <li class='curpepother'><span>课程名称：</span>{{ item.kcmc }}</li>
          <li class='curpepother'><span>上课教师：</span>{{ item.skls }}</li>
          <li class='curpepother'><span>上课人数：</span>{{ item.xkrs }}</li>
          <li class='curpep'><span>授课对象：</span>{{ item.ktmc }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      exchangeList: [],
      initParmer:"",
    };
  },
  methods: {
    // 获取课程列表
    async getList() {
       const params = {
         xnxq:this.$route.query.xnxq,
          xqid:this.$route.query.xqid,
          zc: this.$route.query.zc,
          xingq: this.$route.query.xingq,
          jc:this.$route.query.jc,
          lcxx:this.$route.query.lcxx,
          jsxx:this.$route.query.jsxx,
          jxl:this.$route.query.jxl,
          gnq:this.$route.query.gnq,
        }
      const res = await Api.getTeacherCuMess(params);
      this.exchangeList = res.data;
    }
  },
  created() {
    this.$store.state.teachFindEcach={
    "xnxq":this.$route.query.xnxq,
    "xqid":this.$route.query.xqid,
    "zc":this.$route.query.zc,
    "xingq":this.$route.query.xingq,
    "jc":this.$route.query.jc,
    "lcxx":this.$route.query.lcxx,
    "jsxx":this.$route.query.jsxx,
    "jxl":this.$route.query.jxl,
    "gnq":this.$route.query.gnq,
    };
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.exchange-i {
  .exchange {
    padding: 1% 3% 0;
    overflow: auto;
    height: 90vh;
    .item {
      background: #f8f8f8;
      border-radius: 5px;
      margin: 0 auto 3%;
      padding: 3% 0 3% 3%;
      box-sizing: border-box;
      p {
        height: 22px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #212f6e;
        letter-spacing: 0;
        font-weight: bolder;
        margin-bottom: 2%;
      }
      span {
        height: 22px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #212f6e;
        letter-spacing: 0;
        font-weight: bolder;
        margin-bottom: 2%;
      }
      ul {
        li .curpepother{
          height: 16px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #757da3;
          letter-spacing: 0;
          line-height: 16px;
          margin-bottom: 1%;
        }
      }
      li .curpep {
        height: auto;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #757da3;
          letter-spacing: 0;
          line-height: 16px;
          margin-bottom: 1%;
      }
    }
  }
  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding-bottom: 10px;
    padding: 0 5%;
    background: #fff;
    box-sizing: border-box;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/teachCuseFind/teaChFindList.vue